<template>
  <div class="help-center-post-author__component">
    <div class="help-center-post-author__column">
      <span class="help-center-post-author__label">
        Author
      </span>
      <div class="help-center-post-author__row">
        <img
          :src="authorProps.photo"
          :class="photoClass"
          aria-hidden="true"
          loading="lazy"
          class="help-center-post-author__photo"
        />
        <div>
          <p class="help-center-post-author__name">
            {{ authorProps.name }}
          </p>
          <p
            v-if="!simplified"
            class="help-center-post-author__bio"
          >
            {{ authorProps.bio }}
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="!simplified && authorProps.twitter"
      class="help-center-post-author__column help-center-post-author__column--nowrap"
    >
      <span class="help-center-post-author__label">
        Social
      </span>

      <a
        class="help-center-post-author__link"
        :href="authorProps.twitter.link"
        target="_blank"
        rel="noopener"
      >
        <span class="help-center-post-author__icon fab fa-x-twitter" />
        <span class="help-center-post-author__handle">
          Follow {{ authorProps.twitter.name }}
        </span>
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  post: {
    type: Object,
    required: true
  },
  authorMap: {
    type: Object,
    required: true
  },
  simplified: Boolean
})

const photoClass = computed(() => {
  if (props.simplified) {
    return 'help-center-post-author__photo--small'
  } else {
    return null
  }
})

const authorProps = computed(() => {
  return props.authorMap[props.post.author]
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-post-author {
  &__component {
    gap: $helpCenterMobileVerPadding;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include help-center-breakpoint(md) {
      gap: 24px;
      flex-direction: row;
    }
  }

  &__column {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &--nowrap {
      flex: none;
    }
  }

  &__label {
    @include help-center-font(12);
    color: var(--help-center-muted);
    font-weight: var(--help-center-bold);
    text-transform: uppercase;
  }

  &__row {
    gap: 8px;
    display: flex;
  }

  &__name {
    @include help-center-font(14);
    color: var(--help-center-accent);
    font-weight: var(--help-center-bold);
  }

  &__bio {
    @include help-center-font(14);
    color: var(--help-center-muted);
  }

  &__photo {
    width: 48px;
    height: 48px;
    border-radius: 50%;

    &--small {
      width: 20px;
      height: 20px;
    }
  }

  &__link {
    @include help-center-link;

    gap: 4px;
    display: flex;
    align-items: center;

    color: white;
    width: fit-content;
    padding: 8px 12px;
    border-radius: 20px;
    background-color: $xtwitterBrandColor;
  }

  &__icon {
    @include help-center-icon(20);
  }

  &__handle {
    @include help-center-font(12);
    font-weight: var(--help-center-bold);
  }
}
</style>
